import { render, staticRenderFns } from "./InventoryAdvancePaymentDetailFormDialog.vue?vue&type=template&id=670d1ef0&"
import script from "./InventoryAdvancePaymentDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports